<template>
    <div>
        <div class="day">
            <p class="h3 font-weight-bold">
                {{ dayString }}
            </p>

            <p class="h4">
                {{ timeString }}
            </p>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { SERVER_DATE_FORMAT, SERVER_TIME_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";
    
    export default {
        props: ['day'],

        computed: {
            dayString() {
                return moment(this.day.date, SERVER_DATE_FORMAT).format("dddd Do MMMM");
            },

            timeString() {
                return moment(this.day.start_time, SERVER_TIME_FORMAT).format(LOCAL_TIME_FORMAT) 
                    + " - " 
                    + moment(this.day.end_time, SERVER_TIME_FORMAT).format(LOCAL_TIME_FORMAT);
            }
        }
    }
</script>

<style scoped lang="scss">
    .day {
        // border-top: 1px dashed #e6e6e6;
        padding-top: 1rem;
        margin: 1rem 0;
        &__title{
            font-weight: 500;
        }
        &__body {
            margin-bottom: 5px;
        }
    }
</style>
